
      var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBarcodeFrame = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 182,
  height: 182,
  viewBox: "0 0 182 182",
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#barcode-frame_a92a566f01d03c8d__a)",
  stroke: "var(--theme-primary, #9631ff)",
  strokeWidth: 4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4 4h13M4 4v13M178 4h-13M178 4v13M4 178h13M4 178v-13M178 178h-13M178 178v-13"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "barcode-frame_a92a566f01d03c8d__a",
  x: -8,
  y: -8,
  width: 198,
  height: 198,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_9507_12199"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_9507_12199",
  result: "shape"
})))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"182\" height=\"182\" viewBox=\"0 0 182 182\" fill=\"none\">\r\n  <g filter=\"url(#filter0_d_9507_12199)\">\r\n    <path d=\"M4 4L17 4\" stroke=\"var(--theme-primary, #9631ff)\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <path d=\"M4 4L4 17\" stroke=\"var(--theme-primary, #9631ff)\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <path d=\"M178 4L165 4\" stroke=\"var(--theme-primary, #9631ff)\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <path d=\"M178 4L178 17\" stroke=\"var(--theme-primary, #9631ff)\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <path d=\"M4 178L17 178\" stroke=\"var(--theme-primary, #9631ff)\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <path d=\"M4 178L4 165\" stroke=\"var(--theme-primary, #9631ff)\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <path d=\"M178 178L165 178\" stroke=\"var(--theme-primary, #9631ff)\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n    <path d=\"M178 178L178 165\" stroke=\"var(--theme-primary, #9631ff)\" stroke-width=\"4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n  </g>\r\n  <defs>\r\n    <filter id=\"filter0_d_9507_12199\" x=\"-8\" y=\"-8\" width=\"198\" height=\"198\" filterUnits=\"userSpaceOnUse\" color-interpolation-filters=\"sRGB\">\r\n      <feFlood flood-opacity=\"0\" result=\"BackgroundImageFix\"/>\r\n      <feColorMatrix in=\"SourceAlpha\" type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0\" result=\"hardAlpha\"/>\r\n      <feOffset dy=\"2\"/>\r\n      <feGaussianBlur stdDeviation=\"2\"/>\r\n      <feColorMatrix type=\"matrix\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0\"/>\r\n      <feBlend mode=\"normal\" in2=\"BackgroundImageFix\" result=\"effect1_dropShadow_9507_12199\"/>\r\n      <feBlend mode=\"normal\" in=\"SourceGraphic\" in2=\"effect1_dropShadow_9507_12199\" result=\"shape\"/>\r\n    </filter>\r\n  </defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/barcode-frame.a92a566f01d03c8d46f394c79b52ba3d.svg"),
        {
          React: SvgBarcodeFrame,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      